export default __webpack_public_path__ + "static/media/IMG_20191221_164757.05c2ef7b.jpg";